import {
  IconAddressBook,
  IconAdjustmentsHorizontal,
  IconAffiliate,
  IconAlertTriangle,
  IconArrowBackUp,
  IconArrowLeft,
  IconArrowRight,
  IconArrowsLeftRight,
  IconBell,
  IconBold,
  IconBookmark,
  IconBrandDropbox,
  IconBrandFacebook,
  IconBrandGoogleDrive,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandPinterest,
  IconBrandTelegram,
  IconBrandTiktok,
  IconBrandTumblr,
  IconBrandTwitter,
  IconBrandWhatsapp,
  IconBrandX,
  IconBrandYoutube,
  IconBrowser,
  IconBug,
  IconCalendar,
  IconCalendarEvent,
  IconCalendarPlus,
  IconCamera,
  IconCaretLeft,
  IconCaretRight,
  IconChartDots,
  IconChartPie,
  IconCheck,
  IconChecks,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconCircle,
  IconCircleCheck,
  IconCirclePlus,
  IconCircleX,
  IconClock,
  IconClockX,
  IconCloud,
  IconCode,
  IconCopy,
  IconCreditCard,
  IconCube,
  IconDeviceFloppy,
  IconDeviceMobile,
  IconDots,
  IconDotsVertical,
  IconEye,
  IconFile,
  IconFileInfo,
  IconFileMusic,
  IconFilePencil,
  IconFileText,
  IconFileTypeDoc,
  IconFileTypePdf,
  IconFileTypeXls,
  IconFileTypeZip,
  IconFileZip,
  IconFiles,
  IconFolder,
  IconFolderOpen,
  IconGauge,
  IconGift,
  IconHash,
  IconHeadset,
  IconHeart,
  IconHelpCircle,
  IconInbox,
  IconInfoCircle,
  IconItalic,
  IconKeyboard,
  IconLayoutGrid,
  IconLayoutGridAdd,
  IconLetterT,
  IconLifebuoy,
  IconLink,
  IconList,
  IconListCheck,
  IconListDetails,
  IconLock,
  IconLogin,
  IconLogout,
  IconMail,
  IconMailbox,
  IconMapPin,
  IconMenu2,
  IconMessageChatbot,
  IconMessageCircle,
  IconMessageQuestion,
  IconMessages,
  IconMicrophone,
  IconMinus,
  IconMoodSmile,
  IconNote,
  IconPackages,
  IconPaperclip,
  IconPencil,
  IconPencilPlus,
  IconPhone,
  IconPhoto,
  IconPhotoPlus,
  IconPlayerPlay,
  IconPlugConnected,
  IconPlus,
  IconRefresh,
  IconRepeat,
  IconRocket,
  IconRosetteDiscountCheck,
  IconRotateClockwise,
  IconSearch,
  IconSend,
  IconSettings,
  IconSpeakerphone,
  IconStar,
  IconTag,
  IconThumbUp,
  IconTrash,
  IconUpload,
  IconUser,
  IconUserCog,
  IconUserPlus,
  IconUsers,
  IconUsersGroup,
  IconWand,
  IconX,
  type TablerIcon,
} from "@tabler/icons-react";
import React from "react";

export type IconProps = React.ComponentProps<TablerIcon>;

const iconMap: Record<string, TablerIcon> = {
  "address-book": IconAddressBook,
  "adjustments-horizontal": IconAdjustmentsHorizontal,
  affiliate: IconAffiliate,
  "alert-triangle": IconAlertTriangle,
  "arrow-back-up": IconArrowBackUp,
  "arrow-left": IconArrowLeft,
  "arrow-right": IconArrowRight,
  "arrows-left-right": IconArrowsLeftRight,
  bell: IconBell,
  bold: IconBold,
  bookmark: IconBookmark,
  browser: IconBrowser,
  bug: IconBug,
  calendar: IconCalendar,
  "calendar-event": IconCalendarEvent,
  "calendar-plus": IconCalendarPlus,
  camera: IconCamera,
  "caret-left": IconCaretLeft,
  "caret-right": IconCaretRight,
  "chart-dots": IconChartDots,
  "chart-pie": IconChartPie,
  check: IconCheck,
  checks: IconChecks,
  "chevron-down": IconChevronDown,
  "chevron-left": IconChevronLeft,
  "chevron-right": IconChevronRight,
  circle: IconCircle,
  "circle-check": IconCircleCheck,
  "circle-play": IconPlayerPlay,
  "circle-plus": IconCirclePlus,
  "circle-question": IconHelpCircle,
  "circle-x": IconCircleX,
  close: IconX,
  clock: IconClock,
  "clock-x": IconClockX,
  cloud: IconCloud,
  code: IconCode,
  copy: IconCopy,
  "credit-card": IconCreditCard,
  cube: IconCube,
  "device-mobile": IconDeviceMobile,
  dots: IconDots,
  "dots-vertical": IconDotsVertical,
  eye: IconEye,
  file: IconFile,
  "file-info": IconFileInfo,
  "file-music": IconFileMusic,
  "file-pencil": IconFilePencil,
  "file-text": IconFileText,
  "file-type-doc": IconFileTypeDoc,
  "file-type-pdf": IconFileTypePdf,
  "file-type-xls": IconFileTypeXls,
  "file-type-zip": IconFileTypeZip,
  "file-zip": IconFileZip,
  files: IconFiles,
  folder: IconFolder,
  "folder-open": IconFolderOpen,
  gauge: IconGauge,
  gift: IconGift,
  hash: IconHash,
  headset: IconHeadset,
  heart: IconHeart,
  inbox: IconInbox,
  "info-circle": IconInfoCircle,
  italic: IconItalic,
  keyboard: IconKeyboard,
  "layout-grid": IconLayoutGrid,
  "layout-grid-add": IconLayoutGridAdd,
  "letter-t": IconLetterT,
  lifebuoy: IconLifebuoy,
  link: IconLink,
  list: IconList,
  "list-check": IconListCheck,
  "list-details": IconListDetails,
  lock: IconLock,
  login: IconLogin,
  logout: IconLogout,
  mail: IconMail,
  mailbox: IconMailbox,
  "map-pin": IconMapPin,
  megaphone: IconSpeakerphone,
  menu: IconMenu2,
  "message-chatbot": IconMessageChatbot,
  "message-circle": IconMessageCircle,
  "message-question": IconMessageQuestion,
  messages: IconMessages,
  microphone: IconMicrophone,
  minus: IconMinus,
  "mood-smile": IconMoodSmile,
  note: IconNote,
  packages: IconPackages,
  paperclip: IconPaperclip,
  pencil: IconPencil,
  "pencil-plus": IconPencilPlus,
  phone: IconPhone,
  photo: IconPhoto,
  "photo-plus": IconPhotoPlus,
  "player-play": IconPlayerPlay,
  "plug-connected": IconPlugConnected,
  plus: IconPlus,
  refresh: IconRefresh,
  repeat: IconRepeat,
  rocket: IconRocket,
  "rotate-clockwise": IconRotateClockwise,
  "rosette-discount-check": IconRosetteDiscountCheck,
  save: IconDeviceFloppy,
  search: IconSearch,
  send: IconSend,
  settings: IconSettings,
  star: IconStar,
  tag: IconTag,
  "thumb-up": IconThumbUp,
  trash: IconTrash,
  upload: IconUpload,
  user: IconUser,
  "user-cog": IconUserCog,
  "user-plus": IconUserPlus,
  users: IconUsers,
  "users-group": IconUsersGroup,
  verified: IconRosetteDiscountCheck,
  wand: IconWand,
  x: IconX,
};

const brandIconMap: Record<string, TablerIcon> = {
  "brand-dropbox": IconBrandDropbox,
  "brand-facebook": IconBrandFacebook,
  "brand-google-drive": IconBrandGoogleDrive,
  "brand-instagram": IconBrandInstagram,
  "brand-linkedin": IconBrandLinkedin,
  "brand-pinterest": IconBrandPinterest,
  "brand-telegram": IconBrandTelegram,
  "brand-tiktok": IconBrandTiktok,
  "brand-tumblr": IconBrandTumblr,
  "brand-twitter": IconBrandTwitter,
  "brand-whatsapp": IconBrandWhatsapp,
  "brand-x": IconBrandX,
  "brand-youtube": IconBrandYoutube,
};

function renderIcon(
  Icon: TablerIcon | undefined,
  props: IconProps = {},
  defaults: IconProps = {},
) {
  const IconComponent = Icon || IconCircle;

  return <IconComponent size={18} stroke={2} {...defaults} {...props} />;
}

function resolveBrandIcon(iconName: string) {
  const normalized = iconName.startsWith("brand-")
    ? iconName
    : `brand-${iconName}`;

  return brandIconMap[normalized];
}

export function icon(iconName: string, props?: IconProps) {
  if (iconName.startsWith("brand-")) {
    return brandIcon(iconName, props);
  }

  return renderIcon(iconMap[iconName], props);
}

export function brandIcon(iconName: string, props?: IconProps) {
  return renderIcon(resolveBrandIcon(iconName), props, {
    stroke: 1.75,
  });
}
